import axios from 'axios';
import type { Dispatch } from 'redux';

import type { RootState } from 'vms/app/rootReducer';
import { inspectionResultAddPart } from 'vms/features/inspection/actions';
import { refreshVehicle } from 'vms/features/vehicles/actions';

import * as api from './api';
import type { PartDefinition, Part } from './types';

export const LOAD_PART_DEFINITIONS_SUCCESS = 'LOAD_PART_DEFINITIONS_SUCCESS';
export const LOAD_PARTS_SUCCESS = 'LOAD_PARTS_SUCCESS';
export const PART_DEFINITIONS_LOADED_FOR_TASK = 'PART_DEFINITIONS_LOADED_FOR_TASK';
export const OPEN_PART_DEFINITIONS_EDIT_DIALOG = 'OPEN_PART_DEFINITIONS_EDIT_DIALOG';
export const CLOSE_PART_DEFINITION_EDIT_DIALOG = 'CLOSE_PART_DEFINITION_EDIT_DIALOG';
export const PART_SAVE_SUCCESS = 'PART_SAVE_SUCCESS';
export const PART_DELETE_SUCCESS = 'PART_DELETE_SUCCESS';
export const PART_DEFINITION_DELETE_SUCCESS = 'PART_DEFINITION_DELETE_SUCCESS';

export const loadPartDefinitionsSuccess = (definitions: PartDefinition[]) => ({
  type: LOAD_PART_DEFINITIONS_SUCCESS,
  payload: { definitions },
});

export const closePartDefinitionEditDialog = () => ({
  type: CLOSE_PART_DEFINITION_EDIT_DIALOG,
});

export const definitionsLoadedForTask = (task: string) => ({
  type: PART_DEFINITIONS_LOADED_FOR_TASK,
  payload: { task },
});

export const loadPartsSuccess = (parts: Part[]) => ({
  type: LOAD_PARTS_SUCCESS,
  payload: { parts },
});

export const savePartSuccess = (part: Part) => ({
  type: PART_SAVE_SUCCESS,
  payload: { part },
});

export const openPartDefinitionEditDialog = (definition: PartDefinition | null) => {
  let d: PartDefinition;
  if (definition === null) {
    d = {
      id: '',
      parent: null,
      inspection_task: '',
      name: '',
      is_notes_required: false,
      note_prompt: '',
      children: [],
      default_vendor: null,
    };
  } else {
    d = definition;
  }
  return {
    type: OPEN_PART_DEFINITIONS_EDIT_DIALOG,
    payload: {
      definition: d,
    },
  };
};

export const partDefinitionDeleteSuccess = (definition: PartDefinition) => ({
  type: PART_DEFINITION_DELETE_SUCCESS,
  payload: { definition },
});

export async function savePartAndStore(
  dispatch: Dispatch<any>,
  getState: () => RootState,
  part: Partial<Part>,
  image?: File
): Promise<Part> {
  let payload: FormData | Partial<Part>;
  if (image) {
    const form = new FormData();
    (Object.keys(part) as Array<keyof typeof part>).forEach((key) => {
      const value = part[key];
      if (value !== undefined) {
        form.append(key, value as any);
      }
    });
    form.append('image', image);
    payload = form;
  } else {
    payload = { ...part, image: undefined };
  }
  const response = await api.savePart(payload);
  dispatch(inspectionResultAddPart(response.data.inspection_result, response.data));
  dispatch(savePartSuccess(response.data));
  refreshVehicle(dispatch, getState, response.data.vehicle.id);
  return response.data;
}

export const loadPartDefinitions = () => (dispatch: Dispatch<any>) => {
  return axios
    .get<PaginatedResults<PartDefinition>>('/part-definitions/')
    .then((response) => {
      dispatch(loadPartDefinitionsSuccess(response.data.results));
    });
};
